import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { Header, Footer } from "@/components/site/Chrome";
import { clearIntake } from "@/lib/intake";

export default function Success() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("green-services.success.v1");
    if (!raw) {
      navigate("/", { replace: true });
      return;
    }
    setSummary(JSON.parse(raw));
    clearIntake();
  }, [navigate]);

  if (!summary) return null;

  const dateObj = new Date(`${summary.date}T00:00:00`);
  const nicedate = dateObj.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
  const windowLabel =
    summary.window === "AM" ? "Morning (8am – 12pm)" : "Afternoon (12pm – 5pm)";

  return (
    <>
      <Header />
      <main className="pt-20 pb-16 min-h-screen">
        <div className="max-w-lg mx-auto px-4 sm:px-6 text-center">
          <div className="mx-auto mt-6 flex items-center justify-center w-20 h-20 rounded-full bg-green-100">
            <CheckCircle2
              className="w-12 h-12 text-[#16A34A]"
              strokeWidth={2}
              data-testid="success-check-icon"
            />
          </div>

          <h1
            data-testid="success-headline"
            className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#334E68]"
          >
            Request Received!
          </h1>
          <p className="mt-3 text-base text-gray-600 leading-relaxed">
            Charlie will review your photos and text you shortly to confirm your
            slot.
          </p>

          <div
            data-testid="success-summary"
            className="mt-8 bg-white p-6 rounded-2xl border border-gray-100 shadow-sm text-left"
          >
            <div className="flex justify-between items-baseline">
              <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                Date
              </span>
              <span
                className="text-sm font-medium text-[#334E68]"
                data-testid="success-date"
              >
                {nicedate}
              </span>
            </div>
            <div className="mt-3 flex justify-between items-baseline">
              <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                Window
              </span>
              <span
                className="text-sm font-medium text-[#334E68]"
                data-testid="success-window"
              >
                {windowLabel}
              </span>
            </div>
            <div className="mt-6 pt-4 border-t border-gray-100">
              <div className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                Estimate range
              </div>
              <div
                className="mt-1 font-display text-3xl font-bold text-[#334E68]"
                data-testid="success-estimate"
              >
                ${summary.estimate.low} – ${summary.estimate.high}
              </div>
              <p className="mt-1 text-xs text-gray-500">
                Final price confirmed on-site.
              </p>
            </div>
          </div>

          <Link
            to="/"
            data-testid="back-home-cta"
            className="mt-8 inline-flex items-center justify-center gap-2 min-h-[52px] px-8 bg-white border border-gray-200 hover:bg-gray-50 text-[#334E68] rounded-2xl font-semibold text-sm"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
